import slugify from 'slugify'

import { httpClient } from '@/services/http/httpClient'

import type { IdeaFieldFormat } from '@/types/ideaFieldsFormat'

type Params = {
  id: string
  title: string
  description?: string
  format: IdeaFieldFormat
  options: { name: string }[]
  isMandatory: boolean
}

export async function updateIdeaFieldTemplate({
  id,
  title,
  description,
  format,
  options,
  isMandatory,
}: Params) {
  await httpClient.put(`/ideas/campaigns/field-templates/${id}`, {
    title,
    name: slugify(title, {
      lower: true,
      trim: true,
      replacement: '-',
    }),
    description,
    format,
    formatOptions: options,
    isMandatory,
  })
}
